// extracted by mini-css-extract-plugin
module.exports = {"userGuideLink":"NeedHelpSection_userGuideLink__3fmXD","helpSection":"NeedHelpSection_helpSection__1_vGC"};